import React, { useState, useEffect } from 'react';
import Btn from '../../../Components/Btn';
import SelectCustom from '../../../Components/SelectCustom';
import { Panel, PanelBody, PanelHeader, PanelFooter } from '../../../Components/Panel/Panel';
import { ProductFeedPreview } from '../../../Services/ProductFeedConfigurationServices';
import TableCatalogueContainer from '../../Tooling/ProductFeed/Catalogue/TableCatalogueContainer';
import { ProductRequestResultProduct } from '../../../Services/SearchProductFeedTypes';
import { Spinner } from '../../../Components/Spinner/Spinner';

type PreviewContainerType = {
	loadPreview: (offset: number, limit: number, onSuccess: ((previewResult: ProductFeedPreview) => void), onError) => void,
	handleClosePreview: () => void,
	previewOpened: boolean
}

export default function PreviewContainer({
	loadPreview,
	handleClosePreview,
	previewOpened
}: PreviewContainerType) {

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const [productPage, setProductPage] = useState<ProductRequestResultProduct[]>([]);
	const [pageSize, setPageSize] = useState<number>(10);
	const [hasPrevious, setHasPrevious] = useState<boolean>(false);
	const [hasNext, setHasNext] = useState<boolean>(false);
	const [pageNumber, setPageNumber] = useState<number>(1);

	const pageSizeOptions = [
		{ value: 10, label: 10 },
		{ value: 20, label: 20 },
		{ value: 30, label: 30 },
		{ value: 40, label: 40 },
		{ value: 50, label: 50 },
	];

	const changePageSize = (e) => {
		setProductPage([]);
		const newPageSize = parseInt(e.target.value);
		setPageSize(newPageSize);
	};
	const handleClickOnNext = () => {
		setProductPage([]);
		setPageNumber(c => c + 1);
	};

	const handleClickOnPrevious = () => {
		setProductPage([]);
		setPageNumber(c => c - 1);
	};

	const refreshProductPage = (onSuccess, onError) => {
		const offset = ((pageNumber - 1) * pageSize);
		loadPreview(offset, pageSize, data => {
			setError(null);
			setProductPage(data.products);
			setHasPrevious(pageNumber > 1);
			setHasNext(offset + pageSize < data.totalCount);

			onSuccess();
		}, () => {
			setProductPage([]);
			setError('There is an error in the configuration.');
			onError();
		});
	};

	useEffect(() => {
		if (!previewOpened) return;
		setIsLoading(true);
		setProductPage([]);
		refreshProductPage(() => setIsLoading(false), () => setIsLoading(false));
	}, [previewOpened, pageNumber, pageSize]);

	return (
		<Panel
			isOpen={previewOpened}
			width={1200}
		>
			<PanelHeader
				title="Preview"
				onClose={() => handleClosePreview()}
			/>
			<PanelBody position='relative'>
				{error}
				{!isLoading && !error && 
					<TableCatalogueContainer
						data={productPage}
					/>
				}
				{isLoading &&
					<Spinner />
				}
			</PanelBody>
			{!isLoading && !error &&
				<PanelFooter>
					<div className="flex">
						<div className='flex_item_full'>
							<SelectCustom
								name="totalArticles"
								optionsList={pageSizeOptions}
								onChangeFunction={(e) => changePageSize(e)}
								value={pageSize}
								autoWidth={true}
							/>
							<span className='ml_10 grey_2'>items per page</span>
						</div>
						<div className='flex_item_fix ml_20'>
							{hasPrevious &&
								<Btn
									onClickFunction={() => handleClickOnPrevious()}
									message="Previous"
								/>
							}
							{hasNext &&
								<Btn
									onClickFunction={() => handleClickOnNext()}
									message="Next"
								/>
							}
						</div>
					</div>
				</PanelFooter>
			}
		</Panel>
	);
}